import React, { ReactElement, memo, cloneElement } from "react";
import { COLORS, useThemes } from "core";
import {
  RegisterOptions,
  useFormContext,
  Controller as FORMController,
} from "react-hook-form";
import { Text } from "components/src";
import { createUseStyles } from "react-jss";


const useStyles=createUseStyles<string,unknown,COLORS>((colors)=>({
  error:{
    color:colors.red
  }
}))

interface ControllerProps {
  name: string;
  rules?: RegisterOptions;
  children?: ReactElement;
  errorStyle?: any;
  // Other explicitly defined props...
  // Spread in any extra props
  [key: string]: any;
}

const Controller: React.FC<ControllerProps> = memo(
  ({ name, children, rules, errorStyle, render, ...rest }) => {
    const { control } = useFormContext();
    const { colors } = useThemes();
    const classes=useStyles()
    if (children) {
      return (
        <FORMController
          control={control}
          name={name}
          rules={rules}
          render={({ field, fieldState: { error } }) => (
            <>
              {cloneElement(children, {
                ...field,
                style: {
                  borderColor: error ? colors.red : undefined,
                  ...children.props.style,
                },
              })}
              {error && <Text className={classes.error} style={errorStyle}>{error.message}</Text>}
            </>
          )}
          {...rest}
        />
      );
    } else {
      return <FORMController {...{ control, name, rules, render }} {...rest} />;
    }
  }
);

export { Controller };
